<template>
  <div class="sold">
    <div class="filter-wrapper">
     <div class="inputs-wrapper">
        <h3>Filter po</h3>
        <md-radio v-model="filter" :value="'performance'">Izvedbi</md-radio>
        <md-radio v-model="filter" :value="'id'">Broju transakcije</md-radio>
        <md-radio v-model="filter" :value="'buyer'">Prezimenu</md-radio>
        <md-radio v-model="filter" :value="'date'">Datumu plaćanja</md-radio>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'id'">
        <h3>ID</h3>
        <md-field>
          <label>ID</label>
          <md-input v-model="transactionID"/>
        </md-field>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'buyer'">
        <h3>Prezime</h3>
        <md-field>
          <label>Prezime</label>
          <md-input v-model="buyer"/>
        </md-field>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'date'">
        <h3>Datum</h3>
        <div >
          <md-datepicker v-model="start_date" md-immediately>
            <label>Od</label>
          </md-datepicker>
          <md-datepicker v-model="end_date" md-immediately>
            <label>Do</label>
          </md-datepicker>
        </div>
      </div>
      <div class="inputs-wrapper" v-if="filter == 'performance'">
        <h3>Izvedba</h3>
        <Autocomplete v-model="performanceID" :additionalField="'performance_date'" :stateObject="'performancesSimple'" :searchBy="'play_title'" :returnField="'id'" :label="'Odaberi izvedbu'"/>
      </div>
      <div class="inputs-wrapper">
        <h3>Način plaćanja</h3>
        <md-field>
          <label>Način plaćanja</label>
          <md-select v-model="paymentType">
            <md-option value="all">Svi načini</md-option>
            <md-option value="cash">Gotovina</md-option>
            <md-option value="american">American</md-option>
            <md-option value="diners">Diners</md-option>
            <md-option value="maestro">Maestro</md-option>
            <md-option value="master">Master</md-option>
            <md-option value="visa">VISA</md-option>
            <md-option value="discovery">Discovery</md-option>
            <md-option value="v-pay">V Pay</md-option>
            <md-option value="union-pay">UnionPay</md-option>
            <md-option value="virman">Virman</md-option>
            <md-option value="coupon">Darovni bon</md-option>
          </md-select>
        </md-field>
      </div>
      <div class="inputs-wrapper with-button">
        <md-button class="md-raised md-dense md-primary" v-on:click="filterTransactions()">Prikaži</md-button>
        <md-button class="md-raised md-dense md-accent" :disabled="!searched" v-on:click="clear()">Poništi</md-button>
      </div>
    </div>
    <p class="error-message" style="color: red;text-align: center;font-weight: bold;">
      <span v-for="error in $store.state.errors">
        {{ error }}<br>
      </span>
    </p>
    <md-table v-model="$store.state.receivedData.sold.list" md-sort="id" v-if="$store.state.pageLoaded && $store.state.receivedData.sold.list.length > 0">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Prodano</h1>
        </div>
      </md-table-toolbar>

      <md-table-row md-selectable="single" md-auto-select slot="md-table-row" slot-scope="{ item }" class="table-align-top">
        <md-table-cell md-label="ID" md-sort-by="id" class="md-numeric">{{ item.id }}</md-table-cell>
        <md-table-cell md-label="Izvedba" md-sort-by="data.play_title"><b>{{ item.data.play_title }}</b> - {{ getPlayDate(item.data.performance_time).date }} - {{ getPlayDate(item.data.performance_time).time }}</md-table-cell>
         <md-table-cell md-label="Kupac" class="capitalize">
          <span v-if="item.data.hasOwnProperty('buyer')">
            {{ item.data.buyer[0].first_name }} {{ item.data.buyer[0].last_name }}<br>
            {{ item.data.buyer[0].email }}<br>
            {{ item.data.buyer[0].mobile_phone }}
          </span>
          <span v-if="item.data.hasOwnProperty('employee')">
            {{ item.data.employee.first_name }}<br>
            {{ item.data.employee.last_name }}
          </span>

        </md-table-cell>
        <md-table-cell md-label="Napomena" md-sort-by="data.note" class="capitalize">{{ item.data.note }}</md-table-cell>
        <md-table-cell md-label="Datum plaćanja">{{ item.payment_date }}</md-table-cell>
        <md-table-cell md-label="Vrsta plaćanja" md-sort-by="payment_type" class="capitalize">
          <span v-if="item.payment_type == 'cash'">Gotovina</span>
          <span v-else-if="item.payment_type == 'card'">Kartica/{{ item.card_type }}</span>
          <span v-else-if="item.payment_type === null">Gratis</span>
        </md-table-cell>
        <md-table-cell md-label="Broj rata" md-sort-by="installments">{{ item.installments }}</md-table-cell>
        <md-table-cell md-label="Cijena" md-sort-by="amount">{{ formatCurrency(item.amount) }}</md-table-cell>
        <md-table-cell md-label="Status" md-sort-by="status">{{ getStatus(item.status, item.data.is_cancelled) }}</md-table-cell>
        <md-table-cell md-label="Akcije" class="actions-cell">
          <md-button class="md-raised md-dense md-accent" :disabled="['aborted', 'cancelled'].includes(item.status) || item.disabled" title="Storno" v-on:click="stornoDialog = true; $store.state.selectedObject = JSON.parse(JSON.stringify(item)); clickedItem = item">
            Storno
          </md-button>
          <md-button class="md-raised md-dense md-primary" title="Detalji" v-on:click="showTransaction(item)">
            Detalji
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <h3 v-if="$store.state.receivedData.sold.list.length == 0" class="error">Nažalost nema ništa za prikaz</h3>
    <md-dialog-confirm :md-active="stornoDialog"
                md-title="Storno transakcije"
                md-content="<div id=stornoConfirm class='md-field md-theme-default md-focused md-required'><label for='stornoInfo'>Razlog</label><textarea id='stornoInfo' class='md-input stornoInput'></textarea><br><span class='md-error'>Ovo polje je obavezno</span></div>Jeste li sigurni?"
                md-confirm-text="Potvrdi"
                md-cancel-text="Zatvori"
                v-on:md-confirm="stornoSelected"
                v-on:md-cancel="stornoDialog=false"
                >
    </md-dialog-confirm>
    <TransactionDetails :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page"/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'Sold',
  data(){
    return {
      filter: 'id',
      buyer: '',
      detailsVisible: false,
      end_date: new Date(),
      start_date: new Date(),
      searched: false,
      transactionID: 0,
      performanceID: 0,
      paymentType: 'all',
      stornoDialog: false,
      stornoInfo: '',
    }
  },

  mixins:[FormatCurrency],

  computed:{
    ...mapGetters([
      'getStatus',
      'isPageLoaded',
    ])
  },

  methods: {
    stornoSelected(){
      this.stornoInfo = document.getElementById('stornoInfo').value;
      if(this.stornoInfo == ""){
        document.getElementById("stornoConfirm").classList.add('md-invalid');
        return;
      }
      this.stornoDialog = false;
      this.clickedItem.disabled = true;
      this.$store.state.isTicket = true;
      this.$store.state.currentTransaction = JSON.parse(JSON.stringify(this.$store.state.selectedObject));
      this.$store.dispatch('cancelTransaction', {status: 'cancelled', stornoInfo: this.stornoInfo})
    },

    zeroed(data){
      if(parseInt(data) < 10) return `0${data}`
      return data;
    },

    getPlayDate(data){
      let date = new Date(data);
      return{
        date: `${this.zeroed(date.getDate())}.${this.zeroed(date.getMonth()+1)}.${this.zeroed(date.getFullYear())}`,
        time: `${this.zeroed(date.getHours())}:${this.zeroed(date.getMinutes())}`,
      }
    },

    showTransaction(item){
      this.$store.state.currentTransaction = JSON.parse(JSON.stringify(item));
      this.detailsVisible = true;
    },

    async filterTransactions(){
      this.$store.state.pageLoaded = false;
      this.searched = true;
      let filter = {}
      if(this.filter == 'id') filter['id'] = this.transactionID;
      if(this.filter == 'buyer') filter['buyer'] = this.buyer;
      if(this.filter == 'performance') filter['performance'] = this.performanceID;
      if(this.filter == 'date') {
        if(this.end_date < this.start_date) filter['end_date'] = this.start_date.toLocaleDateString('hr-HR');
        else filter['end_date'] = this.end_date.toLocaleDateString('hr-HR');
        filter['start_date'] = this.start_date.toLocaleDateString('hr-HR');
      }
      filter['payment_type'] = this.paymentType;
      await this.$store.dispatch('getSold', filter)
      this.$store.state.pageLoaded = true;
    },

    async clear(){
      this.$store.state.pageLoaded = false;
      await this.$store.dispatch('getSold');
      this.searched = false;
      this.$store.state.pageLoaded = true;
    }
  },

  watch:{
    isPageLoaded(value){
      if(value && this.transactionID == 0){
        this.transactionID = this.$store.state.receivedData.sold.list.length > 0 ? this.$store.state.receivedData.sold.list[0].id : '';
        this.performanceID = this.$store.state.receivedData.performancesSimple.list.length > 0 ? this.$store.state.receivedData.performancesSimple.list[0].id : '';
      }
    },

    '$store.state.pageLoaded'(){
      this.detailsVisible = false;
    }
  }
}
</script>

<style scoped lang="scss">
.sold{
  .md-table{
    .md-table-cell{
      &.actions-cell{
        width: 254px;
        max-width: 254px;
      }
    }
  }
}

.error{
  font-size: 22px;
  margin: 100px 0 50px 0;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}

.stornoInput{
  resize: none;
  height: 150px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/Sold.vue